import { ON_RPM } from '../../consts.js';

export default function OnRpm(props) {
  if (ON_RPM) {
    return props.children;
  } else {
    return null;
  }
}
